// corporate/html/shop/js/src/retailer.mjs

// from home-2021.js
// import './_site-wide'
// import './shopraise-tracking-pixel'

import '../../../js/corp-2021/src/_site-wide'
import '../../../js/corp-2021/src/shopraise-tracking-pixel'
import Swal from '../../../js/corp-2021/node_modules/sweetalert2/dist/sweetalert2.min.js'

// IIFE
;((d) => {

const favoriteButton = d.getElementById('favorite-button')
const shareButton = d.getElementById('share-button')

/**
 * Favorite button click handler
 * 
 * @param e {mouseEvent}
 * 
 * Calls ajax function to `add` or `remove` the merchant from the favorites.
 * Toggling the buttons `data-is-favorited` from between "0" and "1" will
 * cascade style and text.
 */
favoriteButton && favoriteButton.addEventListener('click', function(e) {

  e.preventDefault()

  // if not logged in & triggering login modal then don't call API
  const notLoggedIn = favoriteButton.classList.contains('login-open-modal')
  if (notLoggedIn) return false;

  const isFavorited = favoriteButton.dataset.isFavorited
  const merchantId = favoriteButton.dataset.merchantId
  
  if (!merchantId) {
    console.log(`Missing required parameters: isFavorited = ${h}${isFavorited}${r}, merchantId = ${h}${merchantId}${r}`);
    return false;
  }

  const baseURL = d.location.protocol + '//' + d.location.host
  const command = (parseInt(isFavorited) ? 'remove' : 'add')

  const url = new URL(`${baseURL}/shop/api/favorites.php/${command}?merchantId=${merchantId}`)

  fetch(url)
    .then(response => response.json())
    .then(response => {
      // console.log(response)
      if (response.error === 0) {
        favoriteButton.dataset.isFavorited = (isFavorited === '1' ? '0' : '1')
      }
    })
    .catch(err => console.error(err));
  
}) // favoriteButton click


/**
 * Retailer share
 * Copy url text to the clipboard
 * 
 * @param e {mouseEvent}
 */
shareButton && shareButton.addEventListener('click', function(e) {
  e.preventDefault()

  const targetURL = shareButton.dataset.socialUrl

  navigator.clipboard.writeText(targetURL)
    .then(() => {
      Swal.fire({
        // toast: true,
        // position: 'center',
        timer: 5000,
        timerProgressBar: true,
        // background: '#eaeaef',
        title: 'Copied to Clipboard',
        html: `The Social Share URL<br>has been copied to the clipboard.`,
        icon: 'success'})
      console.log(`Copied to clipboard: ${targetURL}`)
    })
    .catch(err => console.log('Can\'t copy to clipboard.', err))
  
  return false;
}) // shareButton click

})(document);